
<mat-label class="subHeading">Activation Criteria Rule Name<span *ngIf="isRequired" class="star">*</span></mat-label>
<mat-select formControlName="activation_rule_name" class="activation_rule_name" placeholder="xxxxxxxxxx">
  <mat-option *ngFor="let activationObj of activationRules" [value]="activationObj._id">
    {{ activationObj.rule_name }}
  </mat-option>
</mat-select>

